// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Public_Sans_dbfff2', '__Public_Sans_Fallback_dbfff2'","fontStyle":"normal"},"className":"__className_dbfff2"};